import React from "react";

export default () => {
    return (
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M8.75 0C13.5825 0 17.5 3.91751 17.5 8.75C17.5 13.5825 13.5825 17.5 8.75 17.5C4.25574 17.5 0.554921 14.1115 0.0585938 9.75H1.57031C2.05755 13.2807 5.08531 16 8.75 16C12.7541 16 16 12.7541 16 8.75C16 4.74594 12.7541 1.5 8.75 1.5C6.1189 1.5 3.81718 2.90264 2.54688 5H5.75V6.5H0V0.75H1.5V3.85254C3.07286 1.52843 5.73235 0 8.75 0ZM9.5 8.43945L12.7803 11.7197L11.7197 12.7803L8 9.06055V4.75H9.5V8.43945Z"
                fill="#0049C6"
            />
        </svg>
    );
};
